import { render, staticRenderFns } from "./SelectRestrictionFormElementNew.vue?vue&type=template&id=5b1d1fd0&scoped=true&"
import script from "./SelectRestrictionFormElementNew.vue?vue&type=script&lang=js&"
export * from "./SelectRestrictionFormElementNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1d1fd0",
  null
  
)

export default component.exports